<template>
  <v-container class="d-flex justify-center">
    <v-alert outlined type="info" border="bottom" width="700">
      La visualización de los datos para el empleado
      <span class="font-weight-bold">
        {{ empleadoDatosDesactualizados.nombreCompleto }}
      </span>
      de la empresa
      <span class="font-weight-bold">
        {{ empleadoDatosDesactualizados.DescCompañia }}
      </span>
      se encuentran desactualizados.
      <br />
      Por favor comunicarse con PROFUTURO, BIENESTAR Y PROGRESO S.A.S. para
      obtener más información.
    </v-alert>
  </v-container>
</template>

<script>
export default {
  name: 'DatosDesactualizadosAlert',

  props: {
    empleadoDatosDesactualizados: {
      type: Object,
      required: true,
    },
  },
};
</script>
